import React from "react";
import { useMatch } from "react-router-dom";
import RecordFormResponsesPage from "../tournament-reporting/tournament-record-form-responses";

const TournamentPlayerFormResponses = () => {
  const teamPlayerMatch = useMatch(
    "/:tournamentID/teams/:teamID/players/:playerID/form-responses"
  );
  const teamMatch = useMatch("/:tournamentID/teams/:teamID/form-responses");
  const unassignedMatch = useMatch(
    "/:tournamentID/teams/unassigned-players/:playerID/form-responses"
  );
  const match = teamPlayerMatch ?? teamMatch ?? unassignedMatch;
  const tournamentID = match?.params?.tournamentID;
  const teamID = teamPlayerMatch?.params?.teamID ?? teamMatch?.params?.teamID;
  const playerID =
    teamPlayerMatch?.params?.playerID ?? unassignedMatch?.params?.playerID;

  if (teamPlayerMatch) {
    return (
      <RecordFormResponsesPage
        key={`team-player-${teamID}-${playerID}`}
        tournamentID={tournamentID}
        recordType="players"
        recordKey={playerID}
        viewTeamID={teamID}
        emptyEntity="player"
      />
    );
  }
  if (teamMatch) {
    return (
      <RecordFormResponsesPage
        key={`team-${teamID}`}
        tournamentID={tournamentID}
        recordType="tournament-teams"
        recordKey={teamID}
        emptyEntity="team"
      />
    );
  }
  return (
    <RecordFormResponsesPage
      key={`unassigned-${playerID}`}
      tournamentID={tournamentID}
      recordType="players"
      recordKey={playerID}
      emptyEntity="player"
    />
  );
};

export default TournamentPlayerFormResponses;
